import backgroundImg from '@/assets/images/background.jpg'
import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import Icon from '@/shared/components/atoms/Icon'
import { Link } from '@/shared/components/atoms/Link'

import './register.css'

interface RegisterStep0Props {
	onNextStep: () => void
}

export const RegisterStep0 = ({ onNextStep }: RegisterStep0Props) => {
	const { t } = useTranslation('auth')

	const features = [
		t('register.features.1'),
		t('register.features.2'),
		t('register.features.3'),
	]

	return (
		<div className="flex flex-col items-center text-center h-full">
			{/* Hero Image - Only visible on mobile, cropped to show bottom half */}
			<div className="w-full max-w-md mb-6 overflow-hidden rounded-2xl h-36 md:hidden">
				<img
					src={backgroundImg}
					alt="Brandtrack Dashboard"
					className="w-full h-full object-cover object-bottom scale-125"
				/>
			</div>

			{/* Title */}
			<h1 className="register-title font-bold mb-4">
				{t('register.step0Title')}
			</h1>

			{/* Description */}
			<p className="text-sm text-muted-foreground mb-6 max-w-sm">
				{t('register.startFreeTrial')}
			</p>

			{/* Features */}
			<div className="flex flex-col gap-3 mb-8 w-full max-w-sm">
				{features.map((feature, index) => (
					<div
						key={index}
						className="flex w-full items-center gap-2 rounded-xl border border-transparent bg-[#291d5a] px-4 py-2 text-sm"
					>
						<Icon
							name="check-circle-fill"
							className="shrink-0"
							width="15px"
							height="15px"
							color="#ffffff"
						/>
						<span className="text-sm text-white">{feature}</span>
					</div>
				))}
			</div>

			{/* CTA Button */}
			<Button
				onClick={onNextStep}
				variant="default"
				className="cursor-pointer w-full max-w-sm text-sm font-medium rounded-full"
			>
				{t('register.startFreeTrialCTA')}
			</Button>

			{/* Social proof */}
			<p className="mt-2 text-xs text-muted-foreground italic text-center">
				{t('register.socialProof')}
			</p>

			{/* Sign in link */}
			<div className="mt-4 text-sm">
				<p>
					{t('register.alreadyMember')}{' '}
					<Link className="font-bold underline" to="/login">
						{t('register.signIn')}
					</Link>
				</p>
			</div>

			{/* Terms */}
			<div className="mt-4 text-sm text-muted-foreground">
				<p>
					{t('register.termsAgreementPrefix')}{' '}
					<Link
						className="font-bold underline"
						to="https://www.brandtrack.ai/es/condiciones-generales"
						target="_blank"
					>
						{t('register.termsAndConditions')}
					</Link>
				</p>
			</div>
		</div>
	)
}
